import { createAuthClient } from "better-auth/react";
import environment from "@web-app/src/environments/environment";

export const authClient = createAuthClient({
  baseURL: `${environment.API_HOST}/api/better-auth`,
  fetchOptions: {
    credentials: "include",
    headers: {
      "X-Platform": "webApp",
    },
  },
});

export const { useSession, signIn, signOut, signUp } = authClient;
